module.exports = {
      id: "ic-trend-dark-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-trend-dark-usage",
      toString: function () {
        return this.url;
      }
    }